import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SupabaseAuthCallbackPage } from '../components/SupabaseAuthCallbackPage';
import { ROUTES } from '../routes';

const AuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate(ROUTES.HOME);
  };

  const handleError = () => {
    navigate(ROUTES.LOGIN);
  };

  return (
    <SupabaseAuthCallbackPage
      onSuccess={handleSuccess}
      onError={handleError}
    />
  );
};

export default AuthCallbackPage;
